import React from 'react'
import { cn } from '@nextui-org/react'
import { Typography } from '../Typography'

export interface ProgressBarProps {
  currentStep: number
  totalSteps: number
  className?: string
  showLabel?: boolean
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  totalSteps,
  className,
  showLabel = true
}) => {
  return (
    <div className={cn('w-full', className)}>
      {showLabel && (
        <div className='flex items-center justify-end mb-1'>
          <Typography
            fontFamily='geistMono'
            fontSize='labelSm'
            fontWeight='semibold'
            className='text-tokens-neutral-text-tertiary'
          >
            Step {currentStep} of {totalSteps}
          </Typography>
        </div>
      )}
      <div className='flex items-center gap-[8px] w-full'>
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={cn('h-[8px] rounded-[60px] flex-1', {
              'bg-tokens-status-link-2': index < currentStep,
              'bg-tokens-neutral-fill-fill-6': index >= currentStep
            })}
          />
        ))}
      </div>
    </div>
  )
}
